import { convertUnixTimeToMoment, humanizeIntervalInMinutes } from '../../../common/ItemTools';
import { buildMediaTypeNameMap } from '../../../common/MediaTypes';
import { formatCount } from '../grid/CardGrid';
import reviewedFact from '../stats';

const typeNameMap = buildMediaTypeNameMap();

/**
 * The entity's media-type label, or null when it has no type.
 */
export function typeLabel(entity) {
  const type = entity.type && typeNameMap[entity.type];
  return (type && type.label) || null;
}

/**
 * An entity card's facts line, in display order: what identifies the entity
 * first, then the details a crowded line sheds. `lead` is the media type or,
 * on a list, its author; `details` is zen's switch for everything but the two
 * that identify.
 */
export function entityFacts({
  lead, age, stats, details = true,
}) {
  const { totalItems, timeNeeded } = stats || {};

  return [
    { key: 'lead', text: lead },
    { key: 'count', text: formatCount(totalItems, 'item', 'items') },
    { key: 'age', text: details ? age : null },
    {
      key: 'needed',
      text: details && timeNeeded ? `${humanizeIntervalInMinutes(timeNeeded)} needed` : null,
    },
    { key: 'reviewed', text: details ? reviewedFact(stats) : null },
  ].filter((fact) => fact.text);
}

/**
 * The time strings an entity card's facts line is built from, each null when
 * the entity carries nothing to say it with.
 */
export function timeFacts(entity) {
  return {
    published: entity.timePublished
      ? `${convertUnixTimeToMoment(entity.timePublished)}`
      : null,
    created: entity.timeCreated
      ? `${convertUnixTimeToMoment(entity.timeCreated)}`
      : null,
  };
}
